<template>
  <div class="warning-log-modal">
    <a-modal
      :title="logTitle()"
      :visible="visible"
      @cancel="handleCancel"
      width="600px"
      :centered="true"
      :footer="null"
    >
			<a-table
				:columns="columns"
				:row-key="(record, index) => index"
				:data-source="tableList"
				size="small"
				:loading="loading"
        :pagination="pagination"
        @change="handleTableChange"
        style="padding-bottom: 30px"
			>
				<template slot="warningResultStatus" slot-scope="text">
					<div>{{text === 1?'正常':'异常'}}</div>
				</template>
				<template slot="details" slot-scope="text, record">
          <div v-if="record.warningResultStatus === 0">
            <span>成功
              <a-tooltip placement="right">
                <template slot="title">
                  <div v-for="(v, i) in record.successUserAndReasonResponse" :key="i">
                    <span style="margin-right: 10px">{{v.email}}</span>
                  </div>
                </template>
					      <a-button type="link" class="num-btn">{{record.successUserAndReasonResponse.length}}</a-button>
              </a-tooltip>
            条</span>
            <span>失败
              <a-tooltip placement="right">
                <template slot="title">
                  <div v-for="(v, i) in record.failedUserAndReasonResponse" :key="i">
                    <span style="margin-right: 10px">{{v.email}}</span>
                    <span>{{v['失败原因']}}</span>
                  </div>
                </template>
					      <a-button type="link" class="num-btn">{{record.failedUserAndReasonResponse.length}}</a-button>
              </a-tooltip>
            条</span>
          </div>
        </template>
      </a-table>
    </a-modal>
  </div>
</template>
<script>
import { warningLogList } from "@/api/mediadata"

const columns = [
	{
		title: '时间',
		dataIndex: 'createTime',
		align: 'center',
		width: 155,
	},
	{
		title: '状态',
		dataIndex: 'warningResultStatus',
		scopedSlots: { customRender: 'warningResultStatus' },
		width: 135,
		align: 'left',
	},
  {
		title: '详情',
		dataIndex: 'details',
		scopedSlots: { customRender: 'details' },
		width: 240,
		align: 'left',
	},
]
export default {
  data() {
    return {
      visible: false,
      loading: false,
      tableList: [],
      nowObj: null,
      columns,
			pagination: {
				current: 1,
				total: 0,
				pageSize: 10,
        showTotal: total => `共${total}条`
			},
    };
  },
  props: ['code'],
  methods: {
    init(data) {
      this.visible = true
      this.$nextTick(() => {
        this.nowObj = data
        this.pagination.current = 1
        this.getList()
      })
    },
    handleTableChange(pagination) {
      const pager = { ...this.pagination, current:pagination.current };
			this.pagination = pager;
			this.getList()
		},
    getList() {
      this.loading = true
      warningLogList({
        intelligentWarnTaskId: this.nowObj.id,
        pageSize: this.pagination.pageSize,
        pageNo: this.pagination.current,
      }).then((res) => {
        this.tableList = res.data.recordList || []
        this.pagination.total = res.data.recordCount
      }).finally(() => this.loading = false)
    },
    handleCancel(e) {
      this.tableList = []
      this.visible = false;
    },
    logTitle() {
      return <div>
        <span>预警日志</span>
      </div>
    }
  },
  mounted() {
  }
};
</script>
<style lang="less" scoped>
.title-info {
  font-size: 12px;
  margin-left: 10px;
  color: #677392;
}
.num-btn {
  padding: 0;
  color: #4278FF;
}
</style>